import { useId } from "react";
import { ExternalLink, Github } from "lucide-react";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { webUrl } from "../lib/url";

export function RepositoryLink({ href, label }) {
    const safeHref = webUrl(href);
    if (!safeHref) return null;
    return (
        <a href={safeHref} target="_blank" rel="noreferrer" aria-label={`Abrir repositorio ${label}`}
            className="inline-flex items-center gap-1.5 rounded-md px-2 py-1.5 text-xs font-medium text-slate-700 hover:bg-slate-100">
            <Github className="h-4 w-4" aria-hidden="true" />{label}<ExternalLink className="h-3 w-3 text-slate-400" aria-hidden="true" />
        </a>
    );
}

export function RepositoryLinks({ repositoryUrl, backupRepositoryUrl, currentLabel = "Actual" }) {
    if (!repositoryUrl && !backupRepositoryUrl) return <span className="text-xs text-slate-400">Sin repositorio</span>;
    return (
        <div className="flex flex-wrap gap-1">
            {repositoryUrl && <RepositoryLink href={repositoryUrl} label={currentLabel} />}
            {backupRepositoryUrl && <RepositoryLink href={backupRepositoryUrl} label="Backup" />}
        </div>
    );
}

export function RepositoryField({ label, value, onChange, disabled, id: providedId }) {
    const generatedId = useId();
    const id = providedId || generatedId;
    const safeHref = webUrl(value);
    return (
        <div>
            <Label htmlFor={id}>{label}</Label>
            <div className="mt-1.5 flex gap-2">
                <Input id={id} disabled={disabled} value={value || ""} onChange={(event) => onChange(event.target.value)} placeholder="https://github.com/organizacion/proyecto" />
                {safeHref && <a href={safeHref} target="_blank" rel="noreferrer" aria-label={`Abrir ${label}`}
                    className="inline-flex h-10 items-center justify-center gap-2 rounded-md border border-slate-200 px-3 text-sm text-slate-700 hover:bg-slate-50">
                    <ExternalLink className="h-4 w-4" aria-hidden="true" />Abrir
                </a>}
            </div>
        </div>
    );
}
